var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"vmenu-fade"}},[(_vm.isActive)?_c('div',{staticClass:"vmenu-shadow",on:{"click":_vm.handleShadowClicked}},[_c('TreeViewClose')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }